import React from "react";
import { CONTACT } from "../../data/hseData";

export const WhatsAppFab = () => {
  const msg = encodeURIComponent("Olá HSE, gostaria de uma avaliação técnica.");
  const phone = CONTACT.whatsappLink.replace(/\D/g, "");
  const href = `https://wa.me/${phone}?text=${msg}`;

  return (
    <a
      data-testid="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-5 right-5 z-50 group"
    >
      <div className="relative">
        <span className="absolute inset-0 rounded-full animate-pulse-red" />
        <div className="relative w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] hover:bg-[#1ebe5b] flex items-center justify-center transition-colors shadow-lg shadow-black/40 border-2 border-black/10">
          <svg viewBox="0 0 32 32" className="w-7 h-7 sm:w-8 sm:h-8 fill-white">
            <path d="M19.11 17.18c-.27-.13-1.59-.78-1.84-.87-.25-.09-.43-.13-.61.13-.18.27-.7.87-.86 1.05-.16.18-.32.2-.59.07-.27-.13-1.14-.42-2.17-1.34-.8-.71-1.34-1.6-1.5-1.87-.16-.27-.02-.41.12-.54.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.61-1.47-.83-2.01-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.98 2.64 1.12 2.82.14.18 1.93 2.95 4.68 4.13.65.28 1.16.45 1.56.58.66.21 1.26.18 1.73.11.53-.08 1.59-.65 1.82-1.28.22-.62.22-1.16.16-1.28-.06-.11-.25-.18-.52-.31zM16.02 6C10.49 6 6 10.48 6 16c0 1.77.46 3.43 1.26 4.87L6 26l5.27-1.38c1.4.76 2.99 1.19 4.7 1.19H16c5.52 0 10-4.48 10-10s-4.48-10-10-10z"/>
          </svg>
        </div>
      </div>
    </a>
  );
};

export default WhatsAppFab;
